class YtVideo
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'yt-video--bound'
            @.$playButton = @.$el.querySelector '.yt-video__play-button'
            @.$template = @.$el.querySelector 'template'
            @.$ytIframe = undefined

            @.loaded = @.$el.classList.contains 'yt-video--loaded'

            @.$el.classList.add 'yt-video--bound'
            @.InitEvents()
        return
    
    InitEvents: ->
        self = @
        if !@.loaded
            @.$playButton.addEventListener 'click', (e) ->
                self.AppendTemplateAndLoad()
                return
            
        window.addEventListener 'stopAllYtVideos', (e) ->
            self.PauseVideo()
            return
        return

    AppendTemplateAndLoad: ->
        @.$el.classList.add 'yt-video--loaded'
        @.loaded = true
        @.$el.appendChild document.importNode(@.$template.content, true)
        @.$ytIframe = @.$el.querySelector 'iframe'
        return

    PauseVideo: ->
        if typeof @.$ytIframe != "undefined"
            @.$ytIframe.contentWindow.postMessage '{"event":"command","func":"stopVideo","args":""}', '*'
        return

BindYtVideos = ->
    document.querySelectorAll '.yt-video:not(.yt-video--bound)'
        .forEach (el) ->
            new YtVideo el
            return
    return

window.addEventListener 'bind-components', BindYtVideos